import { useMappingNotificationsByDatasourceId } from "./system/useSelectors";
import { useSystemAdminNotifications } from "./systemAdmin/useSelectors";
import { useTemplateNotificationMessages } from "./template/useSelectors";

export * from "./system/useSelectors";
export * from "./template/useSelectors";

export const useNotificationsCount = () => {
  const templateNotifs = useTemplateNotificationMessages();
  const mappingNotifsByDataSourceId = useMappingNotificationsByDatasourceId();
  const systemAdminNotifs = useSystemAdminNotifications();

  return (
    templateNotifs.length +
    Object.keys(mappingNotifsByDataSourceId).length +
    systemAdminNotifs.length
  );
};
